export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.15-1248.51",
  commitId: "4f1e389c623d15022b42d45d5219390e7fecf1e8",
  commitTime: "2026-06-15T12:48:51.000Z",
});
